import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

export const WhyParth = () => (
  <section id="why-parth" className="py-20 bg-stone-100 border-b border-stone-200" data-testid="why-parth-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="space-y-6"
        >
          <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">Trusted Expertise</span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 font-serif-display">
            Personal attention and honest pricing on every booking
          </h2>
          <p className="text-stone-600 text-base leading-relaxed">
            At Parth Travels, we know that planning a trip shouldn't feel like a second job. With years of hands-on experience, we provide end-to-end guidance from your first enquiry to your safe return.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
            <div className="border-l-2 border-amber-700 pl-4">
              <h4 className="text-base font-bold text-stone-900">Zero Hidden Surcharges</h4>
              <p className="text-xs text-stone-600 mt-1">Clear ticket breakdowns, transparent visa consultation, and honest package costs.</p>
            </div>
            <div className="border-l-2 border-amber-700 pl-4">
              <h4 className="text-base font-bold text-stone-900">Fast &amp; Hassle-Free</h4>
              <p className="text-xs text-stone-600 mt-1">Immediate response on WhatsApp and phone for urgent ticket updates or visa queries.</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="aspect-[4/3] rounded-2xl border border-stone-300 shadow-sm relative overflow-hidden"
        >
          <img
            src={IMAGES.storyDesk}
            alt="Travel consultant reviewing an itinerary with a family"
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-950/70 via-transparent to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <h4 className="text-lg font-bold text-white">The Parth Advantage</h4>
            <p className="text-xs text-stone-200 max-w-xs mt-1">
              Serving travellers across India and managing global holiday circuits with personalized care.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
